import { months } from "../../../../Utils/months";

const validate = values => {
    const errors = {};
    const budgetFincaLatexTable = values.budget_finca_latex_table;

    if (budgetFincaLatexTable) {
        if (budgetFincaLatexTable.generic_row && budgetFincaLatexTable.generic_row.length > 0) {
            const genericRowArrayErrors = [];
    
            budgetFincaLatexTable.generic_row.forEach((row, rowIndex) => {
                const rowErrors = {};
    
                if (!row || !row.name) {
                    rowErrors.name = "requerido";
                }
    
                months.forEach((month) => {
                    const value = parseFloat(row[month]);
                    if (!isNaN(value) && value < 0) {
                        if (!rowErrors[month]) rowErrors[month] = "No se permiten valores negativos";
                    }
                });
    
                if (Object.keys(rowErrors).length > 0) {
                    genericRowArrayErrors[rowIndex] = rowErrors;
                }
            });
    
            if (genericRowArrayErrors.length > 0) {
                errors.budget_finca_latex_table = { generic_row: genericRowArrayErrors };
            }
        }
    }
    

    return errors;
};

export default validate;
